import styled from 'styled-components';
import Button from '@mui/material/Button';

export const CustomButtonStyles = styled(Button)`
  border-radius: 6.3662px;
  box-shadow: none;
`;
